import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.array.map.js";
import React from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import { resolveResponsiveProp } from '../../internal/responsive-props';
import { Box } from '../Box/Box';
import styles from './Tiles.module.less'; // Our designs don't specifically call for 5-column tiles, but it's easier
// to include it that to not because of how we generate our CSS classes in
// `Tiles.module.less`.

/**
 * The `<Tiles>` component can be used for displaying a collection of homogeneous items.
 */
export var Tiles = function Tiles(_ref) {
  var _ref2;

  var columns = _ref.columns,
      collapse = _ref.collapse,
      children = _ref.children,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 3 : _ref$spacing,
      scrollableTileWidth = _ref.scrollableTileWidth;
  var gridColumnsClassName = resolveResponsiveProp(columns, 'grid-columns', styles);
  var flattenedChildren = flattenChildren(children);
  var maybeWrappedChildren = flattenedChildren.map(function (child, index) {
    if (collapse !== 'scroll') {
      // We only need to wrap children if we're configured to collapse to scroll
      return child;
    }

    return /*#__PURE__*/React.createElement(Box // On mobile devices, this will take effect
    , {
      style: {
        width: scrollableTileWidth
      },
      className: [styles['scrollable-child']],
      "data-currency": "Tiles" // Default to child.key to enable users to opt in to keyed
      // children. Since the `React.ReactChild` type includes the
      // `string` type, we need to cast the child to `any` to avoid a
      // TypeScript error.
      ,
      key: child.key || index
    }, child);
  });
  return /*#__PURE__*/React.createElement(Box, {
    display: "grid",
    gridGap: spacing,
    className: [gridColumnsClassName, (_ref2 = {}, _defineProperty(_ref2, styles['collapse-stack'], collapse === 'stack'), _defineProperty(_ref2, styles['collapse-scroll'], collapse === 'scroll'), _ref2)]
  }, maybeWrappedChildren);
};